export const Translations_PT = {
	footer: {
		join: "Junta-te a esta discussão agora. Não é necessário apps ou login.",
		climate: "Uma Discussão Climática positiva.",
		tree: "Esta árvore foi plantada.",
		start: "Começa uma discussão de forma gratuita.",
	},
};
